export default {
  title: '素材ライブラリ',
  tabImage: '画像',
  tabVideo: '動画',
  upload: '画像をアップロード',
  uploadVideo: '動画をアップロード',
  batchGroup: 'グループ移動',
  batchDelete: '一括削除',
  selected: '選択済み',
  item: '件',
  cancelSelect: '選択を解除',
  searchNamePlaceholder: '名前で検索',
  uploadNow: '今すぐアップロード',
  editTitle: '素材を編集',
  materialName: '素材名',
  materialNamePlaceholder: '素材名を入力してください',
  moveGroupTitle: 'グループ移動',
  targetGroup: '移動先グループ',
  selectGroupPlaceholder: 'グループを選択してください',
  confirmDeleteSingle: 'この項目を削除してもよろしいですか？',
  confirmDelete: '選択した項目を削除してもよろしいですか？',
  emptyImage: '画像がありません',
  emptyVideo: '動画がありません',
};
